import React from 'react';
import Header from './components/header';
import Footer from './components/footer';
import GATracker from './components/GATracker';

import Home from './pages/Home';
import Categorys from './pages/Categorys';
import Siteragist from './pages/Siteragist';
import Admin from './pages/Admin';

import './App.css';

import { Routes, Route } from 'react-router-dom';


const GA_TRACKING_ID = 'G-ZW14MV8V78';


function App() {
  return (
    <div className="App">
      <GATracker trackingId={GA_TRACKING_ID} />
      <Header />

      <Routes>

        <Route index  element={<Home />} />
        <Route path="/:category" element={<Categorys />} />
        <Route path="/link" element={<Siteragist />} />
        <Route path="/admin" element={<Admin />} />

      </Routes>

      <Footer />
    </div>
  );
}

export default App;
